export default class EventCustomDefinition {
  constructor(id, color, definition, isDrawable) {
    this._id = id;
    this._color = color;
    this._definition = definition;
    this._isDrawable = isDrawable;
  }

  setIsDrawable(isDrawable) {
    this._isDrawable = isDrawable;
  }

  getId() {
    return this._id;
  }

  getColor() {
    return this._color;
  }

  getDefinition() {
    return this._definition;
  }

  static getIsEditable() {
    return false;
  }

  getIsDrawable() {
    return this._isDrawable;
  }
}

if (typeof window !== 'undefined') window.EventCustomDefinition = EventCustomDefinition;
module.exports = EventCustomDefinition;
